<template>
  <div>
    <Loader v-model="loading" />
    <PrinterDialog v-model="printer" :impresoras="impresoras" />
    <PrinterDialog v-model="printerCorte" :impresoras="impresoras" />

    <!-- HEADER -->
    <v-app-bar app color="primary" dark>
      <v-icon @click="goBack">mdi-keyboard-backspace</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Administrador de Tickets</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon>mdi-account-circle</v-icon>
      {{ session.usuario.toUpperCase() }}
    </v-app-bar>

    <v-main>
      <v-container fluid>

        <v-row>
          <v-col>
            <v-card>
              <v-card-title> Informacion </v-card-title>

              <v-card-text>
                <v-container fluid>

                  <!-- FILTROS -->
                  <v-row>
                    <v-col>
                      <v-select v-model="version" :items="versiones" label="Tipo" item-text="name" item-value="value"
                        outlined />
                    </v-col>

                    <v-col>
                      <v-text-field type="date" label="Fecha Inicio" outlined v-model="info.fecha_inicio" />
                    </v-col>

                    <v-col>
                      <v-text-field type="date" label="Fecha Final" outlined v-model="info.fecha_fin" />
                    </v-col>

                    <v-col>
                      <v-combobox placeholder="Todos" :items="usuarios" item-text="strUsuarioPOS"
                        item-value="strUsuarioPOS" v-model="info.usuario" label="Usuario" outlined dense />
                    </v-col>

                    <v-col md="1">
                      <v-btn x-large block color="primary" @click="buscar()">
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- BOTONES -->
                  <v-row>
                    <v-col>
                      <v-btn x-large block color="primary" @click="printGlobal()">
                        Imprimir Corte Global
                      </v-btn>
                    </v-col>

                    <v-col>
                      <v-combobox placeholder="Seleccione..." :items="impresoras" item-text="name" item-value="address"
                        v-model="info.impresora" label="Impresora" outlined dense />

                    </v-col>

                    <v-col>
                      <v-btn x-large block color="primary" @click="printOrdenes()">
                        Imprimir Grupo de Tickets de venta
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-btn x-large block color="primary" @click="PDFVentas()">
                        Exportar Ventas a PDF
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- ================= TICKET ================= -->
                  <div class="ticket" v-if="ticket" id="element-to-pdf">

                    <div class="center bold">
                      {{ ticket.POSInfo.StrNombre }}
                    </div>
                    <div class="center">
                      {{ ticket.POSInfo.StrResponsable }}
                    </div>
                    <div class="center">
                      {{ ticket.POSInfo.StrRFC }}
                    </div>
                    <div class="center">
                      {{ ticket.POSInfo.StrDireccion }}
                    </div>
                    <div class="center">
                      {{ ticket.POSInfo.StrColonia }}
                    </div>
                    <div class="center">
                      {{ ticket.POSInfo.StrCiudad }}
                    </div>
                    <div class="center">
                      TEL.  {{ ticket.POSInfo.StrTelefono }}
                    </div>
                    <div class="center">
                      QUEJAS Y SUGERENCIAS
                    </div>
                    <div class="center">
                     {{ ticket.POSInfo.StrCorreo }}
                    </div>

                    <hr>

                    <div class="center bold big">
                      TICKET DE PAGO
                    </div>

                    <hr>

                    <div class="left">
                      <div>Tipo Servicio: {{ ticket.strPOSTipoVenta }}</div>
                      <template v-if="!ticket.cliente">
                        <div>Clave: {{ ticket.strMesa }}</div>
                      </template>
                      

                      <template v-if="ticket.cliente">
                      <div>Nombre: {{ ticket.cliente.strNombre }}</div>
                      <div>Telefono: {{ ticket.cliente.strTelefono }}</div>
                      <div>Colonia: {{ ticket.cliente.strColonia }}</div>
                      <div>Referencias: {{ ticket.cliente.strEntreCalle }}</div>
                    </template>

                      <div>No Orden: {{ ticket.intOrden }}</div>
                      <div>Tipo Servicio: {{ ticket.strPOSTipoVenta }}</div>
                      <template v-if="ticket.cliente">
                      <div>Nombre: {{ ticket.cliente.strNombre }}</div>
                      <div>Telefono: {{ ticket.cliente.strTelefono }}</div>
                      <div>Colonia: {{ ticket.cliente.strColonia }}</div>
                      <div>Referencias: {{ ticket.cliente.strEntreCalle }}</div>
                    </template>

                    <template v-if="!ticket.cliente">
                        <div>Clave: {{ ticket.strMesa }}</div>
                      </template>
                     
                      <div>Caja: {{ ticket.StrTerminal }}</div>
                      <div>
                        Fecha: {{ toDateString(ticket.datFecha, 1) }}
                        Hora: {{ new Date(ticket.datFecha).toLocaleTimeString() }}
                      </div>
                      <div>Usuario: {{ ticket.strUsuarioPOS }}</div>
                    </div>
                    <br>
                    <hr>
                    <div class="center bold big">
                    <p style="word-spacing: 65px;">
                    #  PRECIO       TOTAL
                     </p>
                    </div>
                    <hr>
                    <br>
                    <div v-for="d in (ticket.POSDet || [])" :key="d.intPOSDet + '-' + d.strNombre">
                      <div class="center">
  <div style="display: flex; justify-content: space-between; font-size: 12px;">
    <span style="width: 40px;">{{ d.dblCantidad }}</span>
    <span style="flex: 1; text-align: center;">{{ d.strNombre }}</span>
    <span style="width: 80px; text-align: right;">
      {{ isMoney(d.dblTotal) }}
    </span>
  </div>
</div>

  <!-- CONFIGURACIONES -->
  <div 
    v-if="d.posDetArticuloConfiguracion && d.posDetArticuloConfiguracion.length > 0"
    style="margin-left: 10px;"
  >
    <div 
      v-for="c in d.posDetArticuloConfiguracion" 
      :key="c.intPOSDetArticuloConfiguracion"
    >
      <div style="display: flex; justify-content: space-between; font-size: 11px;">
        <span style="width: 40px;">{{ c.dblCantidad }}</span>
        <span style="flex: 1; text-align: left;">- {{ c.strNombre }}</span>
        <span style="width: 80px; text-align: right;">
          {{ isMoney(c.dblTotal) }}
        </span>
      </div>
    </div>
  </div>
                      <hr>
                    </div>
                    <br>
                    <hr>
                    <br>
                    <div class="rowTicket">
                      <span>Subtotal:</span>
                      <span>{{ isMoney(ticket.dblSubtotal) }}</span>
                    </div>

                    <div class="rowTicket">
                      <span>Envio:</span>
                      <span>{{ isMoney(ticket.dblEnvio1) }}</span>
                    </div>

                    <div class="rowTicket">
                      <span>IVA 16%:</span>
                      <span>{{ isMoney(ticket.dblIVA) }}</span>
                    </div>

                    <template v-if="ticket.dblISH != 0">
                      <div class="rowTicket">
                      <span>ISH 3%:</span>
                      <span>{{ isMoney(ticket.dblISH) }}</span>
                    </div>
                    </template>
                    

                    <div class="rowTicket">
                      <span>Descuento:</span>
                      <span>({{ isMoney(ticket.dblImporteDescuento) }})</span>
                    </div>
                    <div class="rowTicket">
                      <span>Total:</span>
                      <span>{{ isMoney(ticket.dblTotal) }}</span>
                    </div>
                    
                    <div class="center big">
                      <span>{{ ticket.StrCantidadLetra }}</span>

                    </div>
                    
                    <hr>
                    <div class="center bold">Pagos</div>
                    <hr>
                    <br>
                    <div 
  v-for="p in (ticket.POSEncPago || []).filter(p => p.dblImporte > 0)" 
  :key="'pago-' + p.intPOSEncPago" 
  class="row"
>
  <div style="display: flex; justify-content: space-between; font-size: 12px;">
    
    <span style="flex: 1; text-align: left;">
      {{ p.strNombre }}
    </span>

    <span style="flex: 1; text-align: center;">
      {{ p.strReferencia || '' }}
    </span>

    <span style="width: 80px; text-align: right;">
      {{ isMoney(p.dblImporte - p.dblCambio) }}
    </span>

  </div>
</div>

                    <br>

                    <div>Repartidor: {{ ticket.StrRepartidor }}</div>

                    <hr>

                    <div class="center">
                      {{ politicas || '' }}
                    </div>

                  </div>
                  <!-- ================= END TICKET ================= -->

                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- ================= RESULTADOS ================= -->
        <v-col>
          <v-card>
            <v-card-title>Resultados</v-card-title>
            <v-card-text>
              <v-container fluid>

                <!-- VENTAS -->
                <v-row v-show="visibleVenta">
                  <v-col>
                    <v-data-table :headers="headers" :items="results" item-key="intPOSEnc" show-expand single-expand
                      :expanded.sync="expandedVentas" @item-expanded="loadDetalleVenta">

                      <template #item.datFecha="{ item }">
                        {{ toDateString(item.datFecha, 1) }}
                      </template>

                      <template #item.intEstatus="{ item }">
                        {{ getEstatus(item.intEstatus) }}
                      </template>

                      <template #item.intPOSTipoServicio="{ item }">
                        {{ getServicio(item.intPOSTipoServicio) }}
                      </template>

                      <template #item.importe="{ item }">
                        {{ isMoney(item.importe) }}
                      </template>

                      <template #item.dblSubtotal="{ item }">
                        {{ isMoney(item.dblSubtotal) }}
                      </template>

                      <template #item.dblTotal="{ item }">
                        {{ isMoney(item.dblTotal) }}
                      </template>

                      <template #body.append="{ headers }">
                        <tr class="summary">
                          <td v-for="(header, i) in headers" :key="i">
                            <div v-if="header.text == 'Subtotal'">
                              {{ isMoney(sumField('dblSubtotal')) }}
                            </div>
                            <div v-if="header.text == 'Total'">
                              {{ isMoney(sumField('dblTotal')) }}
                            </div>
                          </td>
                        </tr>
                      </template>

                      <!-- EXPAND -->
                      <template #expanded-item="{ item, headers }">
                        <td :colspan="headers.length">
                          <v-data-table :headers="headersDetalle" :items="item.detalle || []" item-key="intPOSDet"
                            show-expand single-expand :expanded.sync="item._expandedDetalle" dense
                            @item-expanded="loadConfiguracionDetalle">

                            <template #item.dblPU="{ item }">
                              {{ isMoney(item.dblPU) }}
                            </template>

                            <template #item.dblTotal="{ item }">
                              {{ isMoney(item.dblTotal) }}
                            </template>

                            <template #expanded-item="{ item: detalleItem, headers: h2 }">
                        <td :colspan="h2.length">
                          <v-data-table :headers="headersConfig" :items="detalleItem.configuracion || []" dense
                            hide-default-footer />
                        </td>
                      </template>

                    </v-data-table>
                    </td>
</template>

</v-data-table>
</v-col>
</v-row>

<!-- SALIDAS -->
<v-row v-show="visibleSalidas">
  <v-col>
    <v-data-table :headers="salidaCaja" :items="resultsSalidas">

      <template #item.dblImporte="{ item }">
        {{ isMoney(item.dblImporte) }}
      </template>

      <template #item.intPOSSalidaCaja="{ item }">
        <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="printSalidas(item)"> mdi-print </v-icon>
      </template>

      <template #body.append="{ headers }">
        <tr class="summary">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="header.text == 'Importe'">
              {{ isMoney(sumFieldSC('dblImporte')) }}
            </div>
          </td>
        </tr>
      </template>

    </v-data-table>
  </v-col>
</v-row>

<!-- ARQUEOS -->
<v-row v-show="visibleArqueos">
  <v-col>
    <v-data-table :headers="arqueos" :items="resultsArqueos">

      <template #item.dblImporte="{ item }">
        {{ isMoney(item.dblImporte) }}
      </template>

      <template #item.intPOSTipoMovimientoTurno="{ item }">
        {{ getMovimiento(item.intPOSTipoMovimientoTurno) }}
      </template>

      <template #item.intPOSRegister="{ item }">
        <v-icon small @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="printArqueos(item)"> mdi-printer </v-icon>
      </template>

      <template #body.append="{ headers }">
        <tr class="summary">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="header.text == 'Importe'">
              {{ isMoney(sumFieldAr('dblImporte')) }}
            </div>
          </td>
        </tr>
      </template>

    </v-data-table>
  </v-col>
</v-row>

</v-container>
</v-card-text>
</v-card>
</v-col>

</v-container>
</v-main>
</div>
</template>
<script>
import Loader from "../components/Loader.vue";

//import { Session, Toast, ErrorWeb,Dialog } from "../controllers/DataController.js";
import { Data, Dialog, Toast, Session, ErrorWeb } from "../controllers/DataController.js";
import { POSEncFunctions } from "../controllers/POSController";
import { isMoney, toDateString } from "../js/utilities";
//import { Data } from "../controllers/DataController.js";
import { POSSalidaCaja, POSSalidaCajaFunctions } from "../controllers/POSController";
import { POSRegister, POSRegisterFunctions } from "../controllers/RegisterController.js";
import { POSTerminalFunctions } from "../controllers/POSController.js";
import moment from "moment";
import PrinterDialog from "../components/PrinterDialogComponent.vue";
import Cookies from "js-cookie";
import JSZip from "jszip";




export default {
  data() {
    return {

      ticket: {
        intOrden: '',
        cliente: null,
        strTerminal: '',
        strPOSTipoVenta: '',
        datFecha: new Date(),
        strUsuarioPOS: '',
        politicas: null,
        POSDet: [
          {
            intPOSDet: 0,
            strNombre: '',
            dblCantidad: 0,
            dblPU: 0,
            posDetArticuloConfiguracion: [],
            dblTotal: 0
            
          }
        ],

        terminalUnica: null,

        dblSubtotal: 0,
        dblEnvio1: 0,
        dblIVA: 0,
        dblISH: 0,
        dblImporteDescuento: 0,
        dblTotal: 0,
        StrCantidadLetra: '',

        POSEncPago: [
          { intPOSEncPago: 0, strNombre: '', dblImporte: 0 }
        ],

        StrRepartidor: '',
        POSInfo:[]
      },
      
      // expand nivel ventas
      expandedVentas: [],
      admin: 0,

      headers: [
        { text: '', value: 'data-table-expand' },

        { text: 'Folio', value: 'intFolio' },
        { text: 'Fecha', value: 'datFecha' },
        { text: 'Factura', value: 'intOrden' },
        { text: 'Usuario', value: 'strUsuarioPOS' },
        { text: 'Tipo', value: 'intPOSTipoServicio' },
        { text: 'Estatus', value: 'intEstatus' },
        { text: 'Metodo de Pago', value: 'nombrePago' },
        { text: 'Referencia', value: 'strMesa' },

        { text: 'Importe', value: 'importe' },
        { text: 'Subtotal', value: 'dblSubtotal' },
        { text: 'Total', value: 'dblTotal' }
      ],

      headersDetalle: [
        { text: '', value: 'data-table-expand' },
        { text: 'Clave', value: 'strNombreCorto' },
        { text: 'Artículo', value: 'strNombre' },
        { text: 'PU', value: 'dblPU' },
        { text: 'Cantidad', value: 'dblCantidad' },
        { text: 'Total', value: 'dblTotal' }
      ],

      headersConfig: [
        { text: 'Configuración', value: 'strNombre' },
        { text: 'Cantidad', value: 'dblCantidad' }
      ],

      session: new Session(),
      dataFunctions: new Data(),
      ordenFunctions: new POSEncFunctions(),
      salida: new POSSalidaCaja(),
      datacierreCorte: null,
      salidaFunctions: new POSSalidaCajaFunctions(),
      registerFunctions: new POSRegisterFunctions(),
      terminalFunctions: new POSTerminalFunctions(),
      printerCorte: new Dialog(0, 0, "", "", ""),
      registro: new POSRegister(),
      printer: new Dialog(0, 0, "", "", ""),
      nombreTerminal: "",
      usuarios: [],
      impresorasAdmin: [],
      title: this.$config.ordenTitle,
      impresoras: [],
      versiones: [
        { value: 1, name: "Ventas" },
        { value: 2, name: "Salidas de Caja" },
        { value: 3, name: "Arqueos obligatorios" },
      ],
      version: 1,
      info: {
        usuario: "",

        // fecha_inicio:  moment(new Date()).format("DD/MM/YYYY"),//format("yyyy-MM-DD"),
        // fecha_fin:moment().format("DD/MM/YYYY"),//format("yyyy-MM-DD"),
        fecha_inicio: moment().format("yyyy-MM-DD"),
        fecha_fin: moment().format("yyyy-MM-DD"),
        intPOSRegister: "0"

      },
      loading: false,
      // headers: [
      //   { text: "Folio", value: "intFolio" },
      //   { text: "Fecha", value: "datFecha" },
      //   { text: 'Factura', value: "intOrden" },
      //   { text: "Estatus", value: "intEstatus" },
      //   { text: "Tipo", value: "intPOSTipoServicio" },
      //   { text: "Metodo de Pago", value: "strNombre" },
      //   { text: "Importe", value: "importe" },
      //   { text: "Referencia", value: "strMesa" },
      //   { text: "Subtotal", value: "dblSubtotal" },
      //   { text: "Total", value: "dblTotal" },
      //   { text: "Usuario", value: "strUsuarioPOS" },
      // ],
      // headersDetalle: [
      //   { text: 'Clave', value: 'strNombreCorto' },
      //   { text: 'Artículo', value: 'strNombre' },
      //   { text: 'PU', value: 'dblPU' },
      //   { text: 'Cantidad', value: 'dblCantidad' },
      //   { text: 'Total', value: 'dblTotal' },
      //   { text: '', value: 'data-table-expand' }
      // ],
      // headersConfig: [
      //   { text: 'Configuración', value: 'strNombre' },
      //   { text: 'Cantidad', value: 'dblCantidad' }
      // ],

      salidaCaja: [
        // {text: "#", value: "intPOSTipoSalida", align: ' d-none' },
        { text: "Tipo Salida", value: "strTipoSalida" },
        { text: "Salida", value: "strSalida" },
        { text: "Importe", value: "dblImporte" },
        { text: "Comentario", value: "strComentario" },
        { text: "Empleado", value: "strEmpleado" },
        { text: "Acciones", value: "intPOSSalidaCaja" },
      ],
      arqueos: [
        { text: "Folio", value: "intFolio" },
        { text: "Importe", value: "dblImporte" },
        { text: "Captura", value: "strUsuarioPOS" },
        { text: "Comentario", value: "strComentario" },
        { text: "Tipo", value: "intPOSTipoMovimientoTurno" },
        { text: "Acciones", value: "intPOSRegister" },
      ],
      results: [],
      // POSInfo: null,
      resultsSalidas: [],
      terminal: null,
      resultsArqueos: [],
      visibleVenta: true,
      visibleSalidas: false,
      visibleArqueos: false,
      config_21: this.$config.opciones.find((c) => c.id == 21)
    };
  },
  components: {
    Loader, PrinterDialog,
  },
  watch: {
    ["version"](newVal) {
      if (newVal == 1) {
        this.visibleVenta = true,
          this.visibleSalidas = false,
          this.visibleArqueos = false
      } else if (newVal == 2) {
        this.visibleVenta = false,
          this.visibleSalidas = true,
          this.visibleArqueos = false

      } else {
        this.visibleVenta = false,
          this.visibleSalidas = false,
          this.visibleArqueos = true
      }
    },
    impresoras: {
      handler(val) {
        console.log("IMPRESORAS ACTUALIZADAS:", val);
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    sumField(key) {
      // console.log(key)
      // sum data in give key (property) 
      return this.results.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumFieldSC(key) {
      // console.log(key)
      // sum data in give key (property)
      return this.resultsSalidas.reduce((a, b) => a + (b[key] || 0), 0)
    },
    sumFieldAr(key) {
      // console.log(key)
      // sum data in give key (property)
      return this.resultsArqueos.reduce((a, b) => a + (b[key] || 0), 0)
    },
    isMoney: isMoney,
    toDateString: toDateString,
    getEstatus(intEstatus) {
      if (intEstatus == 2) {
        return "PREPARACION";
      } else if (intEstatus == 4) {
        return "PAGADA";
      } else if (intEstatus == 8 || intEstatus == 9) {
        return "CANCELADA";
      } else return intEstatus;
    },
    goBack() {
      Cookies.remove("POS_USER");
      Cookies.remove("POS_TERMINAL");
      Cookies.remove("POS_REGISTER_CAJA");
      Cookies.remove("POS_TIPO");
      this.$router.push("/Login");
    },
    getServicio(servicio) {
      let config_21 = this.$config.opciones.find((c) => c.id == 21);
      if (config_21.valor) {
        if (servicio == 2) return "FACTURA";
      }
      else {
        if (servicio == 1) return "MESA";
        else if (servicio == 2) return "DOMICILIO";
        else if (servicio == 3) return "LLEVAR";
      }

    },
    getMovimiento(intPOSTipoMovimientoTurno) {
      if (intPOSTipoMovimientoTurno == 1) return "APERTURA";
      else if (intPOSTipoMovimientoTurno == 2) return "ARQUEO";
      else if (intPOSTipoMovimientoTurno == 3) return "CIERRE";
    },
    getExpandedDetalle(venta) {
      // si no existe, lo crea reactivo
      if (!venta._expandedDetalle) {
        this.$set(venta, '_expandedDetalle', [])
      }
      return venta._expandedDetalle
    },

    async loadDetalleVenta({ item, value }) {
      // Solo cargar cuando se expande
      if (!value) return;

      try {
        this.loading = true;
        // Verificar si ya tiene detalle
        if (!item.detalle || item.detalle.length === 0) {
          const detalle = await this.ordenFunctions.getDetalleVenta(item.intPOSEnc);

          // Inicializar cada detalle con su propio control de expansión
          const detalleConConfig = (detalle || []).map(d => ({
            ...d,
            configuracion: [],
            _expandedDetalle: [] // Control individual para cada detalle
          }));

          this.$set(item, 'detalle', detalleConConfig);
        }
      } catch (error) {
        console.error('Error cargando detalle:', error);
        this.$toast.error('Error al cargar el detalle');
      } finally {
        this.loading = false;
      }
    },

    async loadConfiguracionDetalle({ item, value }) {

      // solo cuando se expande
      if (!value) return;

      try {

        // evitar recargas
        if (item.configuracion && item.configuracion.length > 0)
          return;

        const configuracion =
          await this.ordenFunctions.getDetalleVentaConfiguracion(
            item.intPOSDet
          );

        this.$set(item, 'configuracion', configuracion || []);

      } catch (error) {
        console.error('Error cargando configuración:', error);
        this.$toast.error('Error al cargar configuración');
      }
    },

    async buscar() {
      this.loading = true;
      try {

        // if( this.version == 2 && this.info.usuario ==  "")
        //   throw "Seleccione un Usuario";
        console.log("INFO BUSCAR");
        console.log(this.info);
        if (this.version == 1) {
          this.results = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
          console.log(this.results);
          // Reiniciar expandedVentas
          this.expandedVentas = [];

          // Inicializar cada venta
          this.results = this.results.map(venta => ({
            ...venta,
            detalle: [],
            _expandedDetalle: []
          }));

          console.log(this.results);

        } else if (this.version == 2) {
          // Actualizar la carga de usuarios con filtro de fechas
          this.usuarios = await this.dataFunctions.loadUsuariosOrdenesFecha(
            this.info.fecha_inicio,
            this.info.fecha_fin
          );

          const usuarioEncontrado = this.usuarios.find(x => x.strUsuarioAlta == this.info.usuario);
          let intPOSRegister = usuarioEncontrado ? usuarioEncontrado.intPOSRegister : 0;
          this.info.intPOSRegister = String(intPOSRegister);

          if (intPOSRegister == 0) {
            throw "Seleccione un usuario";
          }


          this.resultsSalidas = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
        } else if (this.version == 3) {
          this.resultsArqueos = await this.ordenFunctions.administradorTicket(
            this.session.empresa,
            this.version,
            this.info
          );
        }

      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async PDFVentas() {
  this.loading = true;

  try {
    if (this.version !== 1 || !this.results || this.results.length === 0) {
      alert("PRIMERO NECESITA BUSCAR UN RANGO DE FECHAS Y CARGAR VENTAS");
      return;
    }

    const zip = new JSZip();

    for (const item of this.results) {

      // =========================
      // 1. OBTENER DATA
      // =========================
      const ordenBase = await this.ordenFunctions.getOrdenReimpresionXintPOSEnc(
        this.version,
        item.intPOSEnc
      );

      ordenBase.POSInfo = this.POSInfo;
      ordenBase.StrTerminal = ordenBase.strMaquinaAlta;
      ordenBase.posEncPago = await this.ordenFunctions.pagos(ordenBase.intPOSEnc);

      if (!ordenBase.posDet) {
        ordenBase.posDet = await this.ordenFunctions.detalles(ordenBase.intPOSEnc);
      }

      // =========================
      // 2. ARMAR TICKET
      // =========================
      this.ticket = {
        ...ordenBase,
        POSDet: ordenBase.posDet || [],
        POSEncPago: ordenBase.posEncPago || [],
        StrCantidadLetra: this.numeroALetras(ordenBase.dblTotal)
      };

      // Tipo de venta (tu lógica)
      switch (this.ticket.intPOSTipoVenta) {
        case 0: this.ticket.strPOSTipoVenta = 'LLEVAR'; break;
        case 1: this.ticket.strPOSTipoVenta = 'RAPPI'; break;
        case 2: this.ticket.strPOSTipoVenta = 'UBER'; break;
        case 3: this.ticket.strPOSTipoVenta = 'DIDI'; break;
      }

      // =========================
      // 3. ESPERAR RENDER REAL
      // =========================
      await this.$nextTick();
      await new Promise(r => setTimeout(r, 300));

      const element = document.getElementById('element-to-pdf');

      if (!element) {
        throw "No existe el elemento para exportar";
      }

      // =========================
      // 4. CALCULAR TAMAÑO DINÁMICO
      // =========================
      const heightPx = element.scrollHeight;
      const widthPx = element.scrollWidth;

      const heightIn = heightPx / 96;
      const widthIn = widthPx / 96;

      // =========================
      // 5. CONFIG PDF
      // =========================
      const opt = {
        margin: 0,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: [widthIn, heightIn],
          orientation: 'portrait'
        }
      };

      // =========================
      // 6. GENERAR PDF EN MEMORIA (CLAVE)
      // =========================
      const pdfBlob = await window.html2pdf()
        .set(opt)
        .from(element)
        .outputPdf("blob");

      // =========================
      // 7. AGREGAR AL ZIP
      // =========================
      const fileName = `${this.ticket.intOrden}_${this.ticket.StrTerminal}.pdf`;
      zip.file(fileName, pdfBlob);
    }

    // =========================
    // 8. GENERAR ZIP FINAL
    // =========================
    const zipBlob = await zip.generateAsync({ type: "blob" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(zipBlob);
    const formatFecha = (f) => {
  const d = new Date(f);
  return `${d.getDate().toString().padStart(2,'0')}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getFullYear()}`;
};

const fechaInicio = formatFecha(this.info.fecha_inicio);
const fechaFin = formatFecha(this.info.fecha_fin);

link.download = `Tickets_${this.ticket.StrTerminal}_${fechaInicio}_a_${fechaFin}.zip`;
    link.click();

  } catch (e) {
    console.error(e);
    this.$toast.error(ErrorWeb(e), new Toast());
  } finally {
    this.loading = false;
  }
},

    async printOrdenes() {
      this.loading = true;

      try {
        if (this.version !== 1 || !this.results || this.results.length === 0) {
          alert("PRIMERO NECESITA BUSCAR UN RANGO DE FECHAS Y CARGAR VENTAS");
          return;
        }
        if (this.admin == 1) {
          if (!this.info.impresora) {
            alert("FAVOR DE ELEGIR IMPRESORA");
            return;
          }
        }

        for (const item of this.results) {

          const ordenBase = await this.ordenFunctions.getOrdenReimpresionXintPOSEnc(
            this.version,
            item.intPOSEnc
          );

          ordenBase.POSInfo = this.POSInfo;
          ordenBase.StrTerminal = ordenBase.strMaquinaAlta;
          ordenBase.posEncPago = await this.ordenFunctions.pagos(ordenBase.intPOSEnc);

          if (!ordenBase.posDet)
            ordenBase.posDet = await this.ordenFunctions.detalles(ordenBase.intPOSEnc);

          ordenBase.datFechaImpresion = this.toIsoString(new Date());

          //  CLAVE: destruir instancia anterior
          this.printer.visible = false;
          this.printer.printable = null;

          await this.$nextTick();

          //  Clonar para evitar reutilización reactiva
          const orden = JSON.parse(JSON.stringify(ordenBase));

          if (this.admin == 1) {
             this.impresoras = this.impresoras.map(i => ({
               ...i,
               address: this.info.impresora.address
             }));
          }

          this.printer.event = "pago";
          this.printer.printable = orden;
          if (this.info.impresora) {
            if (!this.printer.printable.POSPrinter) {
              this.printer.printable.POSPrinter = {};
            }

            this.printer.printable.POSPrinter.address = this.info.impresora;
          }
          this.printer.visible = true;

          await this.$nextTick();

          //  Esperar tiempo real suficiente
          await new Promise(resolve => setTimeout(resolve, 1500));
        }

      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    async printGlobal() {
      this.loading = true;
      try {

        if (this.admin == 1) {
          if (!this.info.impresora) {
            alert("FAVOR DE ELEGIR IMPRESORA");
            return;
          }
        }


        let posRegisterGlobal = await this.registerFunctions.getRegisterGlobal(this.info.fecha_inicio);

        if (!posRegisterGlobal) {
          alert("NO SE ENCONTRO CORTE GLOBAL");
          return;
        }

        console.log(this.info.fecha_inicio);
        console.log(this.info.fecha_fin);
        if (this.info.fecha_inicio !== this.info.fecha_fin) {
          alert("DEBE ESCOGER UNA SOLA FECHA PARA SACAR CORTE GLOBAL");
          return;
        }

        let POSRegister1 = await this.ordenFunctions.getArqueos(posRegisterGlobal.intPOSRegister)
        this.datacierre = await this.registerFunctions.cierreReimpresion(posRegisterGlobal.intPOSRegister);
        console.log("POSRegister1")
        console.log(POSRegister1)
        // Calcular importe entregado
        const dblImporteEntregado =
          (this.datacierre?.dblRetiros || 0) +
          (this.registro?.dblOtrosPagos || 0) +
          (this.datacierre?.dblSalidas || 0);

        // Armar el objeto base del ticket
        let POSRegister = {
          strMaquinaAlta: POSRegister1?.strMaquinaAlta || "",
          strUsuarioPOS: POSRegister1?.strUsuarioPOS || "",
          datFechaAlta: this.datacierre?.datFechaInicioTurno
            ? new Date(this.datacierre.datFechaInicioTurno + "Z")
            : null,
          strTerminal: this.nombreTerminal?.strNombre || "",
          dblImporteEntregado,
          // dblDiferencia: dblImporteEntregado - (this.datacierre?.dblVenta || 0),
          // dblImporte: dblImporteEntregado,
          // dblVenta: this.datacierre?.dblVenta || 0,
          // intTotalOrdenesVenta: this.datacierre?.intTotalOrdenesVenta || 0,
          // intTotalPlatillosVenta: this.datacierre?.intTotalPlatillosVenta || 0,
          // intCortesiaCta: this.datacierre?.intCortesiaCta || 0,
          // intCortesiaPlat: this.datacierre?.intCortesiaPlat || 0
        };

        console.log("POSREGISTER ANTES DE DATOS GLOBAL")

        console.log(POSRegister)
        console.log(this.datacierre)


        POSRegister.pagos = await this.registerFunctions.pagosGlobalReimpresion(POSRegister1.intPOSRegisterPadre) || [];
        // POSRegister.salidas = await this.registerFunctions.salidasReimpresion(POSRegister1.intPOSRegisterPadre);
        // POSRegister.dblVentas = await this.registerFunctions.ventasReimpresion(POSRegister1.intPOSRegisterPadre);

        // Complementar con datos del corte
        this.datacierreCorte = await this.registerFunctions.corteGlobal(
          0 || 0,
          POSRegister1.datFechaInicio
        );

        Object.assign(POSRegister, {

          //dblVenta: this.datacierreCorte?.dblVenta || 0,
          dblVenta: this.datacierreCorte?.dblVentaConImpuesto || 0,
          //dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
          dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
          intEnvios: this.datacierreCorte?.intEnvios || 0,
          dblEnvios: this.datacierreCorte?.dblEnvios || 0,
          //intEnvios: this.datacierreCorte?.intEnvios || 0,
          // dblEnvios: this.datacierreCorte?.dblEnvios || 0,
          dblVentaConImpuesto: this.datacierreCorte?.dblVenta || 0,
          //dblVentaConImpuesto: this.datacierreCorte?.dblVentaConImpuesto || 0,

          intTotalOrdenesVenta: this.datacierreCorte?.intTotalOrdenesVenta || 0,
          intTotalPlatillosVenta: this.datacierreCorte?.intTotalPlatillosVenta || 0,
          intCortesiaCta: this.datacierreCorte?.intCortesiaCta || 0,
          intCortesiaPlat: this.datacierreCorte?.intCortesiaPlat || 0,
          intPromCta: this.datacierreCorte?.intPromCta || 0,
          dblPromCta: this.datacierreCorte?.dblPromCta || 0,
          intCancelacionCta: this.datacierreCorte?.intCancelacionCta || 0,
          dblCancelacionCta: this.datacierreCorte?.dblCancelacionCta || 0,
          intCancelacionPlat: this.datacierreCorte?.intCancelacionPlat || 0,
          dblCancelacionPlat: this.datacierreCorte?.dblCancelacionPlat || 0,
          intDescuentoCta: this.datacierreCorte?.intDescuentoCta || 0,
          dblDescuentoCta: this.datacierreCorte?.dblDescuentoCta || 0,
          intDescuentoPlat: this.datacierreCorte?.intDescuentoPlat || 0,
          dblDescuentoPlat: this.datacierreCorte?.dblDescuentoPlat || 0,
          intDevolucionCta: this.datacierreCorte?.intDevolucionCta || 0,
          dblDevolucionCta: this.datacierreCorte?.dblDevolucionCta || 0,
          intDevolucionPlat: this.datacierreCorte?.intDevolucionPlat || 0,
          dblDevolucionPlat: this.datacierreCorte?.dblDevolucionPlat || 0,
          intOrdenesDomicilio: this.datacierreCorte?.intOrdenesDomicilio || 0,
          dblTotalDomicilio: this.datacierreCorte?.dblTotalDomicilio || 0,
          intOrdenesLLevar: this.datacierreCorte?.intOrdenesLLevar || 0,
          dblTotalLLevar: this.datacierreCorte?.dblTotalLLevar || 0,
          intOrdenesMesa: this.datacierreCorte?.intOrdenesMesa || 0,
          dblTotalMesa: this.datacierreCorte?.dblTotalMesa || 0,
          dblFondoCaja: this.datacierreCorte?.dblFondoCaja || 0,
          dblEntregaReal: this.datacierreCorte?.dblEntregaReal || 0,
          dblDiferencia: this.datacierreCorte?.dblDiferencia || 0,
          intRetiroObligatorio: this.datacierreCorte?.intRetiroObligatorio || 0,
          dblRetiroObligatorio: this.datacierreCorte?.dblRetiroObligatorio || 0,
          dblComisiones: this.datacierreCorte?.dblComisiones || 0,
          intIntentos: this.datacierreCorte?.intIntentos || 0,
          dblCompras: this.datacierreCorte?.dblCompras || 0,
          intOrdenesRappi: this.datacierreCorte?.intOrdenesRappi || 0,
          dblTotalRappi: this.datacierreCorte?.dblTotalRappi || 0,
          intOrdenesUber: this.datacierreCorte?.intOrdenesUber || 0,
          dblTotalUber: this.datacierreCorte?.dblTotalUber || 0,
          intOrdenesDidi: this.datacierreCorte?.intOrdenesDidi || 0,
          dblTotalDidi: this.datacierreCorte?.dblTotalDidi || 0
        });
        // 1. Asignar printable
        this.printer.printable = POSRegister;

        // 2. Ahora sí puedes modificar
        if (this.info.impresora) {
          if (!this.printer.printable.POSPrinter) {
            this.printer.printable.POSPrinter = {};
          }
          this.printer.printable.POSPrinter.address = this.info.impresora.address;
        }

        if (this.admin == 1) {
          this.impresoras.forEach(i => {
            i.address = this.printer.printable.POSPrinter.address;
          });
        }

        console.log(this.info.impresora);
        console.log("OBJETO IMPRESORAS");
        console.log(this.impresoras);

        // 3. Debug
        console.log("IMPRESORA FINAL:", this.printer.printable.POSPrinter.address);

        // 4. Imprimir
        this.printer.event = "corteGlobal";
        this.printer.visible = true;
        console.log(POSRegister);
        console.log("Ticket listo para imprimir:", POSRegister);

      }
      catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      }
      finally {
        this.loading = false;
      }


    },
    // async buscar() {
    //   this.loading = true;
    //   try {

    //     if( this.version == 2 && this.info.usuario ==  "")
    //       throw "Seleccione un Usuario";

    //       if(this.version == 1){
    //         this.results = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //         );
    //       }else if(this.version == 2){
    //         let intPOSRegister =this.usuarios.find(x => x.strUsuarioAlta== this.info.usuario).intPOSRegister;
    //         this.info.intPOSRegister =String(intPOSRegister);

    //           this.resultsSalidas = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //        );
    //       }else if(this.version == 3){
    //         this.resultsArqueos = await this.ordenFunctions.administradorTicket(
    //           this.session.empresa,
    //           this.version,
    //           this.info
    //         );

    //       }


    //   } catch (e) {
    //     this.$toast.error(ErrorWeb(e), new Toast());
    //   } finally {
    //     this.loading = false;
    //   }
    // },


    async printSalidas(item) {
      console.log(item.strTipoSalida, item.strSalida, item.strEmpleado)
      this.loading = true;
      try {
        this.salida = await this.salida.RetrieveCaja_id(item.intPOSSalidaCaja);
        console.log(this.salida)
        if (item.intPOSTipoSalida == 2) {
          if (!this.salida.dataDetalleComision)
            this.salida.dataDetalleComision = await this.salida.RetrieveCaja(item.intPOSSalidaCaja);
        }
        this.salida.strPOSTipoSalida = item.strTipoSalida;
        this.salida.strPOSSalida = item.strSalida;
        this.salida.strUsuarioSalida = this.session.usuario;
        this.salida.strEmpleado = item.strEmpleado

        this.salida.POSInfo = this.POSInfo;
        this.salida.StrTerminal = this.session.terminal
        this.salida.strUsuarioAlta = this.session.usuario;
        this.salida.datFechaAlta = this.toIsoString(new Date());


        console.log("salida", this.salida)

        if (this.config_21.valor) {
          this.printer.event = "salidaCajaDicex";
        }
        else
          this.printer.event = "salidaCaja";

        this.printer.visible = true;
        this.printer.printable = this.salida;
        console.log("salida", this.salida)
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    async printArqueos(item) {
      this.loading = true;
      try {

        if (item.intPOSTipoMovimientoTurno == 2) {
          let POSRegister = await this.ordenFunctions.getArqueos(item.intPOSRegister)
          this.printer.event = "arqueo";
          this.printer.visible = true;
          this.printer.printable = POSRegister;
        }
        if (item.intPOSTipoMovimientoTurno == 3) {
          let POSRegister1 = await this.ordenFunctions.getArqueos(item.intPOSRegister)
          this.datacierre = await this.registerFunctions.cierreReimpresion(item.intPOSRegister);
          console.log("POSRegister1")
          console.log(POSRegister1)
          // Calcular importe entregado
          const dblImporteEntregado =
            (this.datacierre?.dblRetiros || 0) +
            (this.registro?.dblOtrosPagos || 0) +
            (this.datacierre?.dblSalidas || 0);

          // Armar el objeto base del ticket
          let POSRegister = {
            strMaquinaAlta: POSRegister1?.strMaquinaAlta || "",
            strUsuarioPOS: POSRegister1?.strUsuarioPOS || "",
            datFechaAlta: this.datacierre?.datFechaInicioTurno
              ? new Date(this.datacierre.datFechaInicioTurno + "Z")
              : null,
            strTerminal: this.nombreTerminal?.strNombre || "",
            dblImporteEntregado,
            dblDiferencia: dblImporteEntregado - (this.datacierre?.dblVenta || 0),
            dblImporte: dblImporteEntregado,
            dblVenta: this.datacierre?.dblVenta || 0,
            intTotalOrdenesVenta: this.datacierre?.intTotalOrdenesVenta || 0,
            intTotalPlatillosVenta: this.datacierre?.intTotalPlatillosVenta || 0,
            intCortesiaCta: this.datacierre?.intCortesiaCta || 0,
            intCortesiaPlat: this.datacierre?.intCortesiaPlat || 0
          };

          console.log("POSREGISTER ANTES DE DATOS GLOBAL")

          console.log(POSRegister)
          console.log(this.datacierre)


          POSRegister.pagos = await this.registerFunctions.pagosReimpresion(POSRegister1.intPOSRegisterPadre) || [];
          POSRegister.salidas = await this.registerFunctions.salidasReimpresion(POSRegister1.intPOSRegisterPadre);
          POSRegister.dblVentas = await this.registerFunctions.ventasReimpresion(POSRegister1.intPOSRegisterPadre);

          // Complementar con datos del corte
          this.datacierreCorte = await this.registerFunctions.corteGlobal(
            POSRegister1.intPOSRegisterPadre || 0,
            POSRegister1.datFechaInicio
          );

          Object.assign(POSRegister, {

            //dblVenta: this.datacierreCorte?.dblVenta || 0,
            dblVenta: this.datacierre?.dblVentaConImpuesto || 0,
            //dblVentaSinImpuesto: this.datacierreCorte?.dblVentaSinImpuesto || 0,
            dblVentaSinImpuesto: this.datacierre?.dblVentaSinImpuesto || 0,
            intEnvios: this.datacierreCorte?.intEnvios || 0,
            dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            //intEnvios: this.datacierreCorte?.intEnvios || 0,
            // dblEnvios: this.datacierreCorte?.dblEnvios || 0,
            dblVentaConImpuesto: this.datacierre?.dblVenta || 0,
            //dblVentaConImpuesto: this.datacierreCorte?.dblVentaConImpuesto || 0,
            intPromCta: this.datacierreCorte?.intPromCta || 0,
            dblPromCta: this.datacierreCorte?.dblPromCta || 0,
            intCancelacionCta: this.datacierreCorte?.intCancelacionCta || 0,
            dblCancelacionCta: this.datacierreCorte?.dblCancelacionCta || 0,
            intCancelacionPlat: this.datacierreCorte?.intCancelacionPlat || 0,
            dblCancelacionPlat: this.datacierreCorte?.dblCancelacionPlat || 0,
            intDescuentoCta: this.datacierreCorte?.intDescuentoCta || 0,
            dblDescuentoCta: this.datacierreCorte?.dblDescuentoCta || 0,
            intDescuentoPlat: this.datacierreCorte?.intDescuentoPlat || 0,
            dblDescuentoPlat: this.datacierreCorte?.dblDescuentoPlat || 0,
            intDevolucionCta: this.datacierreCorte?.intDevolucionCta || 0,
            dblDevolucionCta: this.datacierreCorte?.dblDevolucionCta || 0,
            intDevolucionPlat: this.datacierreCorte?.intDevolucionPlat || 0,
            dblDevolucionPlat: this.datacierreCorte?.dblDevolucionPlat || 0,
            intOrdenesDomicilio: this.datacierreCorte?.intOrdenesDomicilio || 0,
            dblTotalDomicilio: this.datacierreCorte?.dblTotalDomicilio || 0,
            intOrdenesLLevar: this.datacierreCorte?.intOrdenesLLevar || 0,
            dblTotalLLevar: this.datacierreCorte?.dblTotalLLevar || 0,
            intOrdenesMesa: this.datacierreCorte?.intOrdenesMesa || 0,
            dblTotalMesa: this.datacierreCorte?.dblTotalMesa || 0,
            dblFondoCaja: this.datacierreCorte?.dblFondoCaja || 0,
            dblEntregaReal: this.datacierreCorte?.dblEntregaReal || 0,
            dblDiferencia: this.datacierre?.dblDiferencia || 0,
            intRetiroObligatorio: this.datacierreCorte?.intRetiroObligatorio || 0,
            dblRetiroObligatorio: this.datacierreCorte?.dblRetiroObligatorio || 0,
            dblComisiones: this.datacierre?.dblComisiones || 0,
            intIntentos: this.datacierre?.intIntentos || 0,
            dblCompras: this.datacierreCorte?.dblCompras || 0,
            intOrdenesRappi: this.datacierreCorte?.intOrdenesRappi || 0,
            dblTotalRappi: this.datacierreCorte?.dblTotalRappi || 0,
            intOrdenesUber: this.datacierreCorte?.intOrdenesUber || 0,
            dblTotalUber: this.datacierreCorte?.dblTotalUber || 0,
            intOrdenesDidi: this.datacierreCorte?.intOrdenesDidi || 0,
            dblTotalDidi: this.datacierreCorte?.dblTotalDidi || 0
          });

          // Preparar para imprimir
          this.printer.event = "corteTurno";
          this.printer.visible = true;
          this.printer.printable = POSRegister;
          console.log(POSRegister);
          console.log("Ticket listo para imprimir:", POSRegister);
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },

    numeroALetras(num) {
  const unidades = [
    "", "UN", "DOS", "TRES", "CUATRO", "CINCO",
    "SEIS", "SIETE", "OCHO", "NUEVE"
  ];

  const decenas = [
    "DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE",
    "QUINCE", "DIECISEIS", "DIECISIETE",
    "DIECIOCHO", "DIECINUEVE"
  ];

  const dieces = [
    "", "", "VEINTE", "TREINTA", "CUARENTA",
    "CINCUENTA", "SESENTA", "SETENTA",
    "OCHENTA", "NOVENTA"
  ];

  const centenas = [
    "", "CIENTO", "DOSCIENTOS", "TRESCIENTOS",
    "CUATROCIENTOS", "QUINIENTOS",
    "SEISCIENTOS", "SETECIENTOS",
    "OCHOCIENTOS", "NOVECIENTOS"
  ];

  function convertir(n) {
    if (n === 0) return "CERO";
    if (n === 100) return "CIEN";

    let letras = "";

    if (n >= 100) {
      letras += centenas[Math.floor(n / 100)] + " ";
      n %= 100;
    }

    if (n >= 10 && n < 20) {
      letras += decenas[n - 10];
      return letras;
    }

    if (n >= 20) {
      letras += dieces[Math.floor(n / 10)];
      if (n % 10 !== 0) {
        letras += " Y " + unidades[n % 10];
      }
      return letras;
    }

    if (n < 10) {
      letras += unidades[n];
    }

    return letras;
  }

  function miles(n) {
    if (n < 1000) return convertir(n);

    let m = Math.floor(n / 1000);
    let resto = n % 1000;

    let str = m === 1 ? "MIL" : convertir(m) + " MIL";

    if (resto > 0) {
      str += " " + convertir(resto);
    }

    return str;
  }

  let entero = Math.floor(num);
  let decimal = Math.round((num - entero) * 100);

  return `${miles(entero)} PESOS ${decimal.toString().padStart(2, "0")}/100 M.N.`;
},

    toIsoString(date) {
      var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? "+" : "-",
        pad = function (num) {
          var norm = Math.floor(Math.abs(num));
          return (norm < 10 ? "0" : "") + norm;
        };

      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds()) +
        dif +
        pad(tzo / 60) +
        ":" +
        pad(tzo % 60)
      );
    },
    convertDateJSON(POSRegister) {
      if (POSRegister.DatFechaInicio.toString().includes("T")) {
        return POSRegister.DatFechaInicio.toString();
      } else {
        let x = POSRegister.DatFechaInicio.split("/");
        let POSRegister =
          x[2] + "-" + x[1] + "-" + x[0] + "T" + POSRegister.DatHora + ".511Z";
        return POSRegister;
      }
    },
  },
  async mounted() {
    console.log("ENTARDA")
    let session = new Session();
    this.impresoras = await this.dataFunctions.loadImpresorasAdmin(this.admin);
    console.log("IMPRESORAS RAW:", this.impresoras);
    console.log("PRIMERA IMPRESORA:", this.impresoras[0]);
    let strTerminal = Cookies.get('POS_TERMINAL');

if (strTerminal && strTerminal.trim() !== "") {
  // Si existe y no está vacío
  console.log("INFORMACION TERMINAL 1");
  this.terminalUnica = await this.POSTerminalFunctions.retrieveTerminalUnica();
} else {
  // Si no hay cookie o está vacía, se deja nulo
  this.terminalUnica = null;
}
let ticketConfig = JSON.parse(JSON.stringify(this.$config.ticket));
     this.politicas = ticketConfig.find(x => x.id === "politicas_inferior");
  

if (this.politicas) {
    // Aplicas la condición que necesites
    if (this.terminalUnica.strLeyenda && this.terminalUnica.strLeyenda.trim() !== "") {
      this.politicas.valor = this.terminalUnica.strLeyenda;
      this.politicas.valor = this.terminalUnica.strLeyenda.replace(/\r\n|\n|\\n/g, "\r\n");
        console.log("LEYENDA CON VALOR");
    } else {
        // Mantener el valor original del config
        console.log("LEYENDA NULA");
        this.politicas.valor = this.$config.ticket.find(x => x.id === "politicas_inferior").valor;
    }
}
    if (!session.usuario) {
      this.$router.push("/");
    } else {
      this.loading = true;
      try {
        this.usuarios = await this.dataFunctions.loadUsuariosOrdenes();




        this.admin = Cookies.get('POS_ADMIN') ? parseInt(Cookies.get('POS_ADMIN')) : 0;
        this.impresoras = await this.dataFunctions.loadImpresorasAdmin(this.admin);
        console.log(this.impresoras);
        console.log(this.info.impresora);
        //this.terminal = await this.userFunctions.terminal(this.session.terminal);
        this.POSInfo = await this.dataFunctions.loadDataPOSInfo();
        this.terminalFunctions.retrieve().then((res) => {
          this.nombreTerminal = res;
        });

        // this.impresorasAdmin = await this.Data.loadImpresorasAdmin(admin);
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    }
  },
};

</script>

<style>


.ticket hr {
  border: none;
  border-top: 1px dashed #000;
  margin: 4px 0;
}

.center {
  text-align: center;
}

.left {
  text-align: left;
}

.rowTicket {
  display: flex;
  justify-content: space-between;
}

.bold {
  font-weight: bold;
}

.big {
  font-size: 13px;
}
#element-to-pdf {
  width: 3.15in;        
  padding: 0.1in;
  box-sizing: border-box;
}

</style>
